import { useCallback, useEffect, useRef, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { SetSalesOrderReturnAtom, GetSalesOrderReturnAtom } from '../../store/salesOrderReturnAtom';
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import { salesService } from "../../services/sales.service";
import StatusBadge from "../../generals/StatusBadge";


function SalesReturnScroll(props) {
  const mountRef = useRef(true);
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();

  const setSalesReturnAtom = SetSalesOrderReturnAtom();
    const salesReturnAtom = GetSalesOrderReturnAtom();


   useEffect(() => {
      mountRef.current = true;
      if (salesReturnAtom?.so_return_main?.length > 0) {
        setTableData(salesReturnAtom.so_return_main);
      }else{
        getPurchaseOrderListApi();
      }
      return () => {
        mountRef.current = false;
      };
    }, [salesReturnAtom]);



      const getPurchaseOrderListApi = useCallback(async () => {
        try {
          const response = await salesService.getSalesOrderReturnList();
          const serverData =  toLowercaseKeys(response.data);
            setSalesReturnAtom(serverData);
          
        } catch (err) {
         console.log("Error ", err);
        }
      }, []);
    




  return (
    <>
      <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[1000px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px]">
        <div className="border-b-[1px] border-b-gray-300"></div>
        <div className={twMerge(`p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200`)}></div>
        <div>
          {salesReturnAtom?.so_return_main?.map((sales, i) => {
            return (
              <div
                onClick={() => props.viewDetails(sales?.return_ref_no)}
                key={i}
                className={twMerge(
                  `p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200 ${
                    Number(id) === sales?.return_ref_no ? 'bg-gray-200' : 'hover:bg-gray-100'
                  }`
                )}
              >
                <div className="flex flex-row">
                  <div className="ml-1">
                    <div>
                      <span className="text-sm font-bold text-gray-700">{sales?.customer_full_name}</span> <br></br>
                      <span className="text-xs text-gray-400 font-semibold italic">{sales?.sales_order_no}</span>
                      <br></br>
                      <span className="text-sm lg:text-xs font-medium text-gray-600">
                        <CurrencyFormat
                          //   value={parseFloat(sales?.Sales_Order_Amount)?.toFixed(2)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'₦'}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="lg:mt-2 lg:ml-5 ">
                  <div className={twMerge('text-sm font-normal')}>
                    <StatusBadge
                      statusId={sales?.return_status_id}
                      statusName={sales?.return_status_name}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}

export default SalesReturnScroll;
